import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { utils } from "xlsx-js-style";
export var getShopTypeText = function(shopType) {
    var type = Number(shopType);
    if (type === 1) return "RT";
    if (type === 2) return "WT";
    if (type === 3) return "MT";
    return "-";
};
export var getPaymentText = function(payStatus, creditDay) {
    if (Number(payStatus) === 2) {
        return "เครดิต ".concat(Number(creditDay) || 0, " วัน");
    }
    return "เงินสด";
};
export var getBranchGradeText = function(grade) {
    var value = Number(grade);
    return value >= 1 && value <= 4 ? "Level ".concat(value) : "-";
};
var getVatText = function(vatCal) {
    return Number(vatCal) === 2 ? "In VAT" : "Ex VAT";
};
var getCreditStatusText = function(status) {
    return Number(status) === 2 ? "ระงับ" : "ปกติ";
};
export var getShippingPayTypeText = function(payType) {
    return Number(payType) === 2 ? "ปลายทาง" : "ต้นทาง";
};
export var buildSaleIntendantBranchWorksheet = function(datalist) {
    var rows = [
        [
            "ระดับร้านค้า",
            "เซลล์",
            "รหัสร้านค้า",
            "ร้านค้า",
            "รหัสสาขา",
            "สาขา",
            "ประเภทร้าน",
            "เงื่อนไข",
            "วัน เครดิต",
            "การคำนวณ VAT",
            "ระงับวงเงินเครดิต",
            "ข้อมูลจัดส่ง",
            "แขวง",
            "เมือง",
            "บ้าน",
            "วิธีจ่ายเงินค่าขนส่ง",
            "Google Map link",
            "Lat",
            "Long"
        ]
    ].concat(_to_consumable_array(datalist.map(function(row) {
        return [
            Number(row === null || row === void 0 ? void 0 : row.sh_branch_grade) >= 1 && Number(row === null || row === void 0 ? void 0 : row.sh_branch_grade) <= 4 ? Number(row.sh_branch_grade) : "-",
            (row === null || row === void 0 ? void 0 : row.sys_user_fullname) || "-",
            (row === null || row === void 0 ? void 0 : row.sh_shop_code) || "-",
            (row === null || row === void 0 ? void 0 : row.sh_shop_name) || "-",
            (row === null || row === void 0 ? void 0 : row.sh_branch_code) || "-",
            (row === null || row === void 0 ? void 0 : row.sh_branch_name) || "-",
            getShopTypeText(row === null || row === void 0 ? void 0 : row.sh_shop_typeshop),
            Number(row === null || row === void 0 ? void 0 : row.sh_branch_paystatus) === 2 ? "เครดิต" : "เงินสด",
            Number(row === null || row === void 0 ? void 0 : row.sh_branch_creditday) || 0,
            getVatText(row === null || row === void 0 ? void 0 : row.sh_branch_vatcal),
            getCreditStatusText(row === null || row === void 0 ? void 0 : row.sh_branch_creditstatus),
            (row === null || row === void 0 ? void 0 : row.sh_branch_shipping_name) || "-",
            (row === null || row === void 0 ? void 0 : row.sh_branch_province) || "-",
            (row === null || row === void 0 ? void 0 : row.sh_branch_district) || "-",
            (row === null || row === void 0 ? void 0 : row.sh_branch_village) || "-",
            getShippingPayTypeText(row === null || row === void 0 ? void 0 : row.sh_branch_shipping_paytype),
            (row === null || row === void 0 ? void 0 : row.sh_branch_ggmaplink) || "-",
            (row === null || row === void 0 ? void 0 : row.sh_branch_ggmaplat) || "-",
            (row === null || row === void 0 ? void 0 : row.sh_branch_ggmaplong) || "-"
        ];
    })));
    var worksheet = utils.aoa_to_sheet(rows);
    worksheet["!cols"] = [
        {
            wch: 14
        },
        {
            wch: 30
        },
        {
            wch: 18
        },
        {
            wch: 30
        },
        {
            wch: 16
        },
        {
            wch: 28
        },
        {
            wch: 14
        },
        {
            wch: 14
        },
        {
            wch: 14
        },
        {
            wch: 20
        },
        {
            wch: 20
        },
        {
            wch: 24
        },
        {
            wch: 20
        },
        {
            wch: 20
        },
        {
            wch: 20
        },
        {
            wch: 24
        },
        {
            wch: 34
        },
        {
            wch: 14
        },
        {
            wch: 14
        }
    ];
    worksheet["!autofilter"] = {
        ref: "A1:S".concat(Math.max(rows.length, 1))
    };
    worksheet["!rows"] = [
        {
            hpt: 24
        }
    ];
    for(var columnIndex = 0; columnIndex < 19; columnIndex += 1){
        var cellAddress = utils.encode_cell({
            r: 0,
            c: columnIndex
        });
        var isHighlighted = columnIndex === 0 || columnIndex >= 7;
        worksheet[cellAddress].s = {
            font: {
                bold: true,
                color: {
                    rgb: "000000"
                }
            },
            fill: {
                patternType: "solid",
                fgColor: {
                    rgb: isHighlighted ? "FFFF00" : "FFFFFF"
                }
            },
            alignment: {
                vertical: "center",
                horizontal: "left"
            },
            border: {
                top: {
                    style: "thin",
                    color: {
                        rgb: "B7B7B7"
                    }
                },
                bottom: {
                    style: "thin",
                    color: {
                        rgb: "B7B7B7"
                    }
                },
                left: {
                    style: "thin",
                    color: {
                        rgb: "B7B7B7"
                    }
                },
                right: {
                    style: "thin",
                    color: {
                        rgb: "B7B7B7"
                    }
                }
            }
        };
    }
    datalist.forEach(function(row, index) {
        var link = row === null || row === void 0 ? void 0 : row.sh_branch_ggmaplink;
        if (!link) return;
        var address = utils.encode_cell({
            r: index + 1,
            c: 16
        });
        worksheet[address].l = {
            Target: link,
            Tooltip: "เปิด Google Maps"
        };
        worksheet[address].s = {
            font: {
                color: {
                    rgb: "0000FF"
                },
                underline: true
            }
        };
    });
    return worksheet;
};
